import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { removeLoginLS } from "@delibrandev/utils";
import { apiRest } from "../api/constants";
import { setUserLogOut, setAlert } from "../reducers/userConfigSlice";

export default function useOperationalAccess() {
  const dispatch = useDispatch();
  const logged = useSelector(state => state.aplicationConfig.userConfig.logged);
  useEffect(() => {
    if (!logged) return undefined;
    let stopped = false;
    let pending = false;
    const check = async () => {
      if (stopped || pending) return;
      pending = true;
      try {
        await axios.get(`${apiRest.replace(/\/$/, "")}/access-session`, { withCredentials: true });
      } catch (error) {
        if (!stopped && [400, 401, 403].includes(error?.response?.status)) {
          stopped = true;
          removeLoginLS(apiRest);
          dispatch(setUserLogOut());
          dispatch(setAlert({ called: true, title: "Acceso revocado", message: "Tu acceso operativo ha cambiado. Vuelve a identificarte.", type: "error" }));
        }
      } finally { pending = false; }
    };
    check();
    const timer = setInterval(check, 3000);
    return () => { stopped = true; clearInterval(timer); };
  }, [dispatch, logged]);
}
